import { TopicPack } from "@/types";

const covid19: TopicPack = {
  id: "covid-19",
  sku: "pack-covid-19",
  name: "COVID-19",
  topics: [
    [
      "$1,200 Stipend",
      "Dr. Anthony Fauci",
      "Full Hospitals",
      "Governer Andrew Cuomo",
      "Hand Sanitizer",
      "Immunocompromised",
      "Influenza Strains",
      "Lysol Wipes",
      "Medical Gloves",
      "Pandemics",
      "Pangolins",
      "Plummeting Economy",
      "Pneumonia",
      "Respiratory Droplets",
      "Shelter in Place",
      "Social Distancing",
      "Surgical Mask",
      "The Spanish Flu",
      "Tiger King",
      "Toilet Paper",
      "Tylenol",
      "Vaccine Development",
      "Ventillators",
      "Wiping it Down",
      "Working from Home",
      "Zoom.us",
    ],
  ],
};

export default covid19;
